import request from "@/utils/request";
export function fetchList(data) {
  return request({
    url: "/whg-park/api/theaterArea/list",
    method: "post",
    data: data
  });
}
export function fetchDetail(data) {
  return request({
    url: "/whg-park/api/theaterArea/get",
    method: "post",
    data: data
  });
}
export function fetchDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: "/whg-park/api/theaterArea/delete",
    method: "post",
    data: data
  });
}
export function fetchCreate(data) {
  return request({
    url: "/whg-park/api/theaterArea/insert",
    method: "post",
    data: data
  });
}
export function fetchUpdate(data) {
  return request({
    url: "/whg-park/api/theaterArea/update",
    method: "post",
    data: data
  });
}